import Cookies from 'js-cookie'

const tokenKey = 'Authorization'
const userKey = 'userInfo'

// 经测试sessionStorage存储时，在浏览器新打开标签页时不共享，所以选择用localStorage存储，配合Cookies关闭浏览器登录失效

export function setToken (token) {
  const loginTime = new Date().getTime().toString()
  Cookies.set('login-time', loginTime)
  localStorage.setItem('login-time', loginTime)
  return localStorage.setItem(tokenKey, token)
}

export function getToken () {
  const loginTime = Cookies.get('login-time')
  const loginTime2 = localStorage.getItem('login-time')
  if (loginTime2 != loginTime) {
    removeToken()
  }
  return localStorage.getItem(tokenKey)
}

export function removeToken () {
  removeUser()
  return localStorage.removeItem(tokenKey)
}

export function setUser (info) {
  return localStorage.setItem(userKey, info)
}

export function getUser () {
  let user = localStorage.getItem(userKey)
  if (user) {
    user = JSON.parse(user)
  }
  return user
}

export function removeUser () {
  return localStorage.removeItem(userKey)
}
